import apiSsoService from '../../services/apiSsoService'
import apiService from '../../services/apiService'
import axios from 'axios'

export default {
  getAccount: async function ({ commit }) {
    try {
      var businessId = sessionStorage.getItem('businessId')
      var response = await apiSsoService.get(
        businessId ? `/api/member/profile/${businessId}` : '/api/member/profile'
      )
      const account = response.data.result
      if (account) {
        commit('SET_ACCOUNT', account)
        this.dispatch('login/setIsAuthenticated', 'true')
      }
      return response
    } catch (error) {
      return error
    }
  },
  patchAccount: async function (store, payload) {
    try {
      var response = await apiSsoService.patch('/api/member/profile', payload)
      return response
    } catch (error) {
      return error
    }
  },
  revokeLine: async function ({ commit }) {
    try {
      await apiSsoService.delete('/api/member/revoke-line')
      await this.getAccount({ commit })
    } catch (error) {
      return error
    }
  },
  revokeFacebook: async function ({ commit }) {
    try {
      await apiSsoService.delete('/api/member/revoke-facebook')
      await this.getAccount({ commit })
    } catch (error) {
      return error
    }
  },

  getMemberRole: async function () {
    try {
      var response = await apiSsoService.get(
        '/api/channel/member-role-dropdown'
      )
      return response
    } catch (error) {
      return error
    }
  },
  getProfileMembers: async function (store, payload) {
    try {
      const business_id =
        payload.business_id || sessionStorage.getItem('businessId')
      var response = await apiSsoService.get(
        `/api/channel/profile/${business_id}/member`,
        { ...payload, business_id }
      )
      return response
    } catch (error) {
      return error
    }
  },
  postProfileMember: async function (store, payload) {
    try {
      const business_id = payload.id || sessionStorage.getItem('businessId')
      var response = await apiSsoService.post(
        `/api/channel/profile/${business_id}/member`,
        payload
      )
      return response
    } catch (error) {
      return error
    }
  },
  patchProfileMember: async function (store, payload) {
    try {
      const business_id =
        payload.business_id || sessionStorage.getItem('businessId')
      var response = await apiSsoService.patch(
        `/api/channel/profile/${business_id}/member/${payload.id}`,
        payload
      )
      return response
    } catch (error) {
      return error
    }
  },
  getProfile: async function (store, payload) {
    try {
      const business_id =
        payload.business_id || sessionStorage.getItem('businessId')
      var response = await apiSsoService.get(
        `/api/channel/profile/${business_id}`,
        { ...payload, business_id }
      )
      return response
    } catch (error) {
      return error
    }
  },
  deleteProfile: async function (store, payload) {
    try {
      var response = await apiSsoService.delete(
        `/api/channel/profile/${payload}`
      )
      return response
    } catch (error) {
      return error
    }
  },
  deleteProfileMember: async function (store, payload) {
    try {
      const business_id =
        payload.business_id || sessionStorage.getItem('businessId')
      var response = await apiSsoService.delete(
        `/api/channel/profile/${business_id}/member/${payload.id}`
      )
      return response
    } catch (error) {
      return error
    }
  },

  deleteBusiness: async function () {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.delete(
        `/api/business/profile/${business_id}/delete-business`
      )
      return response
    } catch (error) {
      return error
    }
  },
  getBusinessProfile: async function (store, payload) {
    try {
      var response = await apiSsoService.get('/api/channel/profile', payload)
      return response
    } catch (error) {
      return error
    }
  },
  getProfileSelection: async function (store, payload) {
    try {
      var response = await apiSsoService.get(
        '/api/channel/profile-selection',
        payload
      )
      return response
    } catch (error) {
      return error
    }
  },
  getBusinessType: async function () {
    try {
      var response = await apiSsoService.get(
        '/api/channel/business-type-dropdown'
      )
      return response
    } catch (error) {
      return error
    }
  },
  getMemberRolePermission: async function ({ commit }, payload) {
    try {
      const business_id = payload.id || sessionStorage.getItem('businessId')
      var response = await apiService.get(
        `/api/business/profile/${business_id}/role-permission`
      )
      commit('SET_MEMBER_ROLE_PERMISSION', response.data.result)
      return response
    } catch (error) {
      return error
    }
  },
  patchProfile: async function (store, payload) {
    try {
      var response = await apiSsoService.patch(
        `/api/channel/profile/${payload.id}`,
        payload
      )
      return response
    } catch (error) {
      return error
    }
  },
  postProfile: async function (store, payload) {
    try {
      var response = await apiSsoService.post('/api/channel/profile', payload)
      return response
    } catch (error) {
      return error
    }
  },
  postAccountConnectApp: async function (store, payload) {
    try {
      var response = await apiSsoService.post(
        `/api/channel/profile/${payload.businessId}/connect-app/${7}`
      )
      return response
    } catch (error) {
      return error
    }
  },
  postLead: async function (store, payload) {
    try {
      const page = 'CMS RICHMENU'
      var response = await axios.post(
        `https://api-sme-prod.zwiz.app/lead-form/${page}/lead`,
        payload
      )
      return response
    } catch (error) {
      return error
    }
  }
}
